<div id="login" fxLayout="row" fxLayoutAlign="start">

 
    <div id="login-intro" fxFlex fxHide fxShow.gt-xs>

    </div>
    <div id="login-form-wrapper" fusePerfectScrollbar *fuseIfOnDom [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}">

        <div id="login-form">

            <img src="assets/images/logos/logo.jpg" />
          
            <form name="formGroup" [formGroup]="formGroup" novalidate>

                <mat-form-field>
                    <input matInput placeholder='{{ translations != undefined ? (translations.txtUsername) : "" }}' formControlName="Username" 
                    [(ngModel)]="user.UserName" [readonly]="disabledForm">
                    <mat-error *ngIf="formGroupErrors.Username.required">
                        {{ (translations != undefined ? translations.lblUsernameRequired : '') }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field>
                    <input type="password" matInput placeholder='{{ translations != undefined ? (translations.txtPassword) : "" }}' formControlName="Password" 
                    [(ngModel)]="user.Password" [readonly]="disabledForm" >
                    <mat-error *ngIf="formGroupErrors.Password.required">
                            {{ translations != undefined ? (translations.lblPasswordRequired) : '' }}
                    </mat-error>
                </mat-form-field>

                <!-- <div class="remember-forgot-password" fxLayout="row" fxLayout.xs="column"
                     fxLayoutAlign="space-between center">
                   

                    <a class="forgot-password" [routerLink]="'/resetpassword'" class="customBlueFont">
                       {{translations.lnkForgotPassword}}
                    </a>
                </div> -->

                <button mat-raised-button color="accent" class="submit-button" style="float: right;" aria-label="LOG IN"
                        [disabled]="formGroup.invalid || disabledForm" (click)="login();">
                       {{ translations != undefined ? (translations.btnLogin) : '' }}
                </button>
                    
            </form>
        </div>
        <div style="width:100% !important;text-align: right;bottom: 0;position: absolute">({{versionDetails?.VersionNumber}} {{versionDetails?.VersionDate}})</div>

    </div>
 

</div>


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/login/login.component.html